import { removeEmptyObjects } from 'util/removeEmptyObjects'
import { doPost, doPost2ErrorHandling } from '../common'
import { getIncommUtmPayload } from './utm'

/**
 * Generate email verification token for Incomm offer redemption with Turnstile protection
 * This sends the verification email and includes turnstile token for rate limiting
 */
export const generateIncommTokenService = async ({
  email,
  firstName,
  lastName,
  offerId,
  turnstileToken,
  type = 'EMAIL',
}: {
  email: string
  firstName?: string
  lastName?: string
  offerId: string
  turnstileToken?: string
  type?: string
}) => {
  const payload = removeEmptyObjects({
    email,
    firstName: firstName || email,
    lastName: lastName || '',
    tokenSource: 'INCOMM_OFFER',
    type: type.toUpperCase(),
    turnstileToken,
  })

  // Use richer error handling so UI can react to status codes/details (e.g., already requested)
  return doPost2ErrorHandling(`/token/generate-token`, payload)
}

/**
 * Generates barcode after validating email verification token
 *
 * Backend will:
 * 1. Validate the 6-digit email verification token (REQUIRED)
 * 2. Check if token is not expired
 * 3. Verify email ownership
 * 4. Check offer customer limit
 * 5. Generate and return the barcode (or return existing if at limit)
 *
 * Note: Turnstile validation happens at token generation time, not here
 *
 * @returns Barcode response object on success, throws error on validation failure
 */
export const validateTokenAndGenerateBarcode = async ({
  email,
  token,
  offerId,
  selectedBannerStoreId,
  barcodeFormat = 'CODE_128',
  quantityLimit,
  type = 'EMAIL',
  autoSendEmail,
  checkboxesAccepted,
}: {
  email: string
  token: string
  offerId: string
  selectedBannerStoreId?: string
  barcodeFormat?: string
  quantityLimit?: number
  type?: string
  autoSendEmail?: boolean
  checkboxesAccepted?: Array<{
    checkboxId: string
    label: string
    required: boolean
    accepted: boolean
  }>
}) => {
  const utmPayload = await getIncommUtmPayload()

  const payload = removeEmptyObjects({
    email,
    token,
    offerId,
    selectedBannerStoreId,
    barcodeFormat,
    quantityLimit,
    tokenSource: 'INCOMM_OFFER',
    type,
    autoSendEmail,
    checkboxesAccepted,
    ...utmPayload,
  })

  return doPost2ErrorHandling('/incomm/barcode/generate', payload)
}
